/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: { 'note': attributeToString(note) },
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status + '): ' + data.description);
    }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, form);updateFreeShippingThersold();} else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
    $(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function(cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
            $('.one_time').slick({
                infinite: false,
                speed: 500,
                slidesToShow: 1,
                arrows: true,
                prevArrow: $('.prev'),
                nextArrow: $('.next'),
                adaptiveHeight: false,
                slidesToScroll: 1
            });
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }
        $(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);updateFreeShippingThersold();} else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                errorCallback(XMLHttpRequest, textStatus);
            },
                complete: function(jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

    'use strict';

    // Public functions
    var init, loadCart;

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

    // Private functions
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function(options) {

        // Default settings
        settings = {
            formSelector: 'form[action^="/cart/add"]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: '#CartCount',
            cartCostSelector: null,
            moneyFormat: '$',
            disableAjaxCart: false,
            enableQtySelectors: true
        };

        // Override defaults with arguments
        $.extend(settings, options);

        // Select DOM elements
        $formContainer = $(settings.formSelector);
        $cartContainer = $(settings.cartContainer);
        $addToCart = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector = $(settings.cartCostSelector);

        // console.log(settings.formSelector, '========>formContainer');
        // console.log(form, '====>form');
        // console.log($addToCart, '=========>addToCart');

        // General Selectors
        $body = $(document.body);

        // Track cart activity status
        isUpdating = false;

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride($formContainer);
        }
        if (!settings.disableAjaxCart) {
            formOverride($('#upsell_form'));
        }
        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
    };

    loadCart = function() {
        if (!$body) $body = $(document.body);
        $body.addClass('drawer--is-loading');
        // ShopifyAPI.getCart(cartUpdateCallback);
        ShopifyAPI.getCart(function(cart) {
            cartUpdateCallback(cart); // re-render drawer
            let has_chosen_card = false;
            document.querySelectorAll(".gift-cards-option").forEach((el, i) => {
                if (el.classList.contains("disabled")) {
                    
                }else{
                    if(!has_chosen_card) {
                        el.classList.add("active");
                        has_chosen_card = true;
                    }
                }
            });

            let box_variant_id = Number(document.querySelector(".checkbox__gift-box").getAttribute('data-box-variant'));
            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                    const found = cart.items.some(item => item.id === box_variant_id);
                    if (found) {
                        document.querySelector(".cart-gift-checkbox").classList.add('has-box');
                        document.querySelector(".checkbox__gift-box").checked = true;
                        document.querySelector(".bg-product").classList.remove('hide-m');
                        document.querySelector(".bg-product").classList.add('flex');
                        document.querySelector(".total-gift-box").classList.remove('hide-m');
                        document.querySelector(".total-gift-box").classList.add('flex');
                    }
                    const checkbox_gift_card = document.querySelector('.checkbox__gift-card');

                    const checkbox_gift_card_ids = Object.keys(checkbox_gift_card.dataset)
                    .filter(key => key.startsWith('cardVariant'))
                    .map(key => Number(checkbox_gift_card.dataset[key]));
                    const found_card = cart.items.some(item => checkbox_gift_card_ids.includes(item.product_id));
                    const found_card_data = cart.items.find(item => checkbox_gift_card_ids.includes(item.product_id));
                    if(found_card) {
                        document.querySelector(".checkbox__gift-card").checked = true;
                        document.querySelector(".gift-cards-area").classList.remove('hide-m');
                        document.querySelector(".gift-cards-area").classList.add('flex');
                        document.querySelector(".total-gift-card").classList.remove('hide-m');
                        document.querySelector(".total-gift-card").classList.add('flex');
                        document.querySelectorAll(".gift-cards-option").forEach(el => {
                            el.classList.remove('active');
                            if (Number(el.getAttribute('data-variant')) === found_card_data.id ) {
                                el.classList.add('active');
                            }
                        });
                        if(found_card_data?.properties?.sender_name) {
                            document.querySelector(".gift-cards-form-sender").value = found_card_data.properties.sender_name;
                        }
                        if(found_card_data?.properties?.recipient_name) {
                            document.querySelector(".gift-cards-form-recipient").value = found_card_data.properties.recipient_name;
                        }
                        if(found_card_data?.properties?.message) {
                            document.querySelector(".gift-cards-form-message").value = found_card_data.properties.message;
                            const charCount = document.querySelector('.gift-cards-form-message-count');
                            const currentLength = found_card_data.properties.message.length;
                            const maxLength = 110;
                            charCount.textContent = `${currentLength}/${maxLength}`;
                        }
                        if(found_card_data?.properties?.blank_card == "Yes") {
                            document.querySelector(".gift-cards-form-blank").value = found_card_data.properties.blank_card;
                            document.querySelector(".gift-cards-form-blank").checked = true;
                        }
                    }
                    // Show "(Edit)" label when gift card or gift box is in cart
                    var editLabel = document.querySelector('.gifting-edit-label');
                    if (editLabel) {
                        if (found || found_card) {
                            editLabel.classList.remove('hide-m');
                        } else {
                            editLabel.classList.add('hide-m');
                        }
                    }
                });

            // 👇 Run your teleport/move logic *after* the drawer updates
            requestAnimationFrame(() => {
                const elements = document.querySelectorAll('.gift-cards-zoom');
                const target = document.querySelector('#CartDrawer');
                elements.forEach(el => target.appendChild(el));
            });
        });
    };

    updateCountPrice = function(cart) {
        console.log("update count price");
        if ($cartCountSelector) {
            console.log("update cart count selector");
            $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
            if(document.querySelector("#CartCountDrawer")){
                document.querySelector("#CartCountDrawer").innerHTML = "(" + cart.item_count + ")";
            }
            if (cart.item_count === 0) {
                $('.cart-count-bubble').hide();
            } else {
                $('.cart-count-bubble').show();
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
        }
    };

    formOverride = function(form) {
        form.on('submit', function(evt) {
            evt.preventDefault();

            // Add class to be styled if desired
            $addToCart.removeClass('is-added').addClass('is-adding');
            // Remove any previous quantity errors
            $('.qty-error').remove();

            // console.log("data that is pased");
            //   console.log(evt.target);

            ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
        });
    };

    itemAddedCallback = function(product) {
        $addToCart.removeClass('is-adding').addClass('is-added');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    itemErrorCallback = function(XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        $addToCart.removeClass('is-adding is-added');

        if (!!data.message) {
            if (data.status == 422) {
                $cartContainer.before('<div class="errors qty-error">' + data.description + '</div>')
            }
        }
    };

    cartUpdateCallback = function(cart) {
        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart);
    };

    buildCart = function(cart) {
        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
            $('#CartContainer').addClass('empty_CartDrawer');
            $('#is-a-gift').hide();
            $cartContainer
                .append('<p>Your cart is empty</p>');
            cartCallback(cart);
            return;
        } else {
            $('#CartContainer').removeClass('empty_CartDrawer');
            $('#is-a-gift').show();
        }

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);

        // Add each item to our handlebars.js data
        $.each(cart.items, function(index, cartItem) {

            if (cartItem.image != null) {
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_180X$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }

            // Create item's data object and add to 'items' array
            item = {
                key: cartItem.key,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title,
                variation: cartItem.variant_title,
                properties: cartItem.properties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                vendor: cartItem.vendor,
                linePrice: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
                unitPrice: Shopify.formatMoney(cartItem.unit_price, settings.moneyFormat),
                discountedPrice: Shopify.formatMoney(cartItem.discounted_price, settings.moneyFormat),
                prounitPrice: Shopify.formatMoney(cartItem.unit_price),
                originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
                discounts: cartItem.discounts,
                discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
            };
            items.push(item);
        });
        // Gather all cart data and add to DOM
        data = {
            items: items,
            note: cart.note,
            totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
            totalCartDiscount: cart.total_discount === 0 ? 0 : Shopify.formatMoney(cart.total_discount, settings.moneyFormat),
            totalCartDiscountApplied: cart.total_discount === 0 ? false : true
        }

        $cartContainer.append(template(data));

        // Update promo text after the template is rendered.
        // All copy and config comes from theme settings via data attributes — no fallbacks.
        var $promoContainer = $cartContainer.find('.cart-promo-collection');
        if ($promoContainer.length && $promoContainer[0].dataset) {
            var promoData = $promoContainer[0].dataset;
            var promoIds = (promoData.cartPromoProductIds || '').split(',').map(function(id) {
                    return parseInt(id, 10);
                }).filter(Boolean);
            var promoType = promoData.cartPromoType || 'amount';
            var promoCollectionUrl = promoData.cartPromoCollectionUrl || '';
            var promoBonusUrl = promoData.cartPromoCollectionBonusUrl || '';
            var promoBonusId = parseInt(promoData.cartPromoBonusId, 10) || 0;
            var promoAmount = parseFloat(promoData.cartPromoCollectionAmount) || 0;
            var promoImage = promoData.cartPromoCollectionImage || '';
            var promoTextNone = promoData.cartPromoTextNone || '';
            var promoTextProgress = promoData.cartPromoTextProgress || '';
            var promoTextReward = promoData.cartPromoTextReward || '';
        var promoThreshold = Math.round(promoAmount * 100);

            // The bonus (free) product never counts towards its own promo.
            // The promo message is only dropped once the bonus is in the cart AND its
            // line discount is applied — a bonus in the cart without the discount means
            // the customer still has no qualifying item and should keep seeing the promo.
            var promoQty = 0;
            var promoValue = 0;
            var promoBonusDiscounted = false;
                for (var i = 0; i < cart.items.length; i++) {
                if (promoBonusId && cart.items[i].product_id === promoBonusId) {
                    if (cart.items[i].line_price !== cart.items[i].original_line_price) {
                        promoBonusDiscounted = true;
                    }
                    continue;
                }
                    if (promoIds.indexOf(cart.items[i].product_id) !== -1) {
                    promoQty += cart.items[i].quantity;
                        promoValue += Number(cart.items[i].line_price) || 0;
                    }
                }

            var formatPromoNumber = function(value) {
                return value % 1 === 0 ? value.toString() : value.toFixed(2);
            };
            var promoTokens = {
                qty: promoQty,
                amount: formatPromoNumber(promoAmount),
                remaining: formatPromoNumber(Math.max(0, promoThreshold - promoValue) / 100)
            };
            var renderPromoText = function(text) {
                var html = text
                    .replace(/\[collection\]([\s\S]*?)\[\/collection\]/g, promoCollectionUrl ? '<a href="' + promoCollectionUrl + '">$1</a>' : '$1')
                    .replace(/\[bonus\]([\s\S]*?)\[\/bonus\]/g, promoBonusUrl ? '<a href="' + promoBonusUrl + '">$1</a>' : '$1');
                for (var token in promoTokens) {
                    html = html.split('[' + token + ']').join(promoTokens[token]);
                }
                return html;
            };

            var promoText = '';
            if (promoIds.length && !promoBonusDiscounted) {
                if (promoType === 'quantity' || promoThreshold <= 0) {
                    // One reward per qualifying item, no minimum amount
                    promoText = promoQty > 0 ? renderPromoText(promoTextReward) : renderPromoText(promoTextNone);
                } else if (promoValue >= promoThreshold) {
                    promoText = renderPromoText(promoTextReward);
                } else if (promoValue > 0) {
                    promoText = renderPromoText(promoTextProgress);
            } else {
                    promoText = renderPromoText(promoTextNone);
                }
            }

            if (promoText) {
            var promoInner = promoImage
                ? '<img class="cart-promo-collection__image" src="' + promoImage + '" alt="">' + '<span class="cart-promo-collection__text">' + promoText + '</span>'
                : promoText;
            $promoContainer.removeClass('hide-m').html(promoInner);
            } else {
                $promoContainer.addClass('hide-m').empty();
            }
        }

        console.log("cart data");
        console.log(data);

        cartCallback(cart);
    };

    cartCallback = function(cart) {
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }

        $cartContainer.find('#note[name="note"]').val(cart.note);
    };

    adjustCart = function() {
        // Delegate all events because elements reload with the cart
        //Remove Item from cart
        $body.on('click', '.ajaxcart__remove', function() {
            var $el = $(this),
                line = $el.data('line');
            updateQuantity(line, 0);
            $el.addClass('clicked');
            setTimeout(function() {
                $el.removeClass('clicked');
            }, 3000);
        })

        
        //clicking "next" button on cart — directly triggers checkout
        $body.on('click', '.cart__next', function(e) {
            e.preventDefault();
            var checkoutBtn = document.querySelector('.cart__next__checkout');
            if (checkoutBtn) checkoutBtn.click();
        });

        $body.on('click', '.cart-gift-back', function(e) {
            e.preventDefault();
            var cartNext         = document.querySelector(".cart__next");
            var cartNextCheckout = document.querySelector(".cart__next__checkout");
            var cartMiddle       = document.querySelector(".cart-middle");
            var cartGiftCheckbox = document.querySelector(".cart-gift-checkbox");
            var cartGiftBack     = document.querySelector(".cart-gift-back");
            if (cartNext)         cartNext.classList.remove('hide-m');
            if (cartNextCheckout) cartNextCheckout.classList.add('hide-m');
            if (cartMiddle)       cartMiddle.classList.remove('hide-m');
            if (cartGiftCheckbox) cartGiftCheckbox.classList.add('hide-m');
            if (cartGiftBack)     cartGiftBack.classList.add('hide-m');
        });

        $body.on('click', '.gift-cards-option', function(e) {
            if(e.currentTarget.classList.contains("disabled")) {
                return;
            }
            document.querySelectorAll(".gift-cards-option").forEach(el => {
                el.classList.remove('active');
            });
            e.currentTarget.classList.add('active');
            // Hide design error once a card is selected
            document.querySelector('.gift-error-design')?.classList.add('hide-m');
            updateGiftCardState();
        });

        $body.on('change', '.checkbox__gift-card', function() {
            if(document.querySelector(".checkbox__gift-card").checked){
                document.querySelector(".gift-cards-area").classList.remove('hide-m');
                document.querySelector(".gift-cards-area").classList.add('flex');
                updateGiftCardState();
            } else {
                document.querySelector(".gift-cards-area").classList.add('hide-m');
                document.querySelector(".gift-cards-area").classList.remove('flex');
                // Hide all error hints
                document.querySelector('.gift-error-design')?.classList.add('hide-m');
                document.querySelector('.gift-error-recipient')?.classList.add('hide-m');
                document.querySelector('.gift-error-sender')?.classList.add('hide-m');
                document.querySelector('.gift-error-message')?.classList.add('hide-m');
                updateGiftCardState();
                // Remove gift card from cart and do partial UI refresh
                giftCardRemoveFromCart(function() {
                    fetch('/cart.js')
                        .then(function(r) { return r.json(); })
                        .then(function(cart) {
                            partialCartRefresh(cart, { hideGiftCard: true });
                        });
                });
            }
        });

        $body.on('change', '.gift-cards-form-blank', function() {
            if(document.querySelector(".gift-cards-form-blank").checked){
                document.querySelector(".gift-cards-form-recipient").value = "";
                document.querySelector(".gift-cards-form-recipient").setAttribute('disabled', 'true');
                document.querySelector(".gift-cards-form-sender").value = "";
                document.querySelector(".gift-cards-form-sender").setAttribute('disabled', 'true');
                document.querySelector(".gift-cards-form-message").value = "";
                document.querySelector(".gift-cards-form-message").setAttribute('disabled', 'true');
                document.querySelector(".gift-cards-form-message").dispatchEvent(new Event('input', { bubbles: true }));
                document.querySelector('.gift-error-recipient')?.classList.add('hide-m');
                document.querySelector('.gift-error-sender')?.classList.add('hide-m');
                document.querySelector('.gift-error-message')?.classList.add('hide-m');
            } else {
                document.querySelector(".gift-cards-form-recipient").removeAttribute('disabled');
                document.querySelector(".gift-cards-form-sender").removeAttribute('disabled');
                document.querySelector(".gift-cards-form-message").removeAttribute('disabled');
            }
            updateGiftCardState();
        });

        $body.on('change', '.checkbox__gift-box', function(e) {
            var boxVariantId = Number(e.currentTarget.getAttribute('data-box-variant'));
            if(document.querySelector(".checkbox__gift-box").checked){
                document.querySelector(".bg-product").classList.remove('hide-m');
                document.querySelector(".bg-product").classList.add('flex');
                // Add gift box to cart then partial refresh
                if (boxVariantId) {
                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: JSON.stringify({ items: [{ id: boxVariantId, quantity: 1 }] })
                    })
                    .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
                    .then(function(cart) {
                        partialCartRefresh(cart, { showGiftBox: true });
                    })
                    .catch(function(err) { console.error('[gift-box] add error:', err); });
                }
            } else {
                document.querySelector(".bg-product").classList.add('hide-m');
                document.querySelector(".bg-product").classList.remove('flex');
                // Remove gift box from cart then partial refresh
                if (boxVariantId) {
                    fetch('/cart.js')
                        .then(function(r) { return r.json(); })
                        .then(function(cart) {
                            var item = cart.items.find(function(i) { return i.id === boxVariantId; });
                            if (!item) return Promise.reject('not-found');
                            return fetch('/cart/change.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                                body: JSON.stringify({ id: item.key, quantity: 0 })
                            })
                            .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
                            .then(function(updatedCart) {
                                partialCartRefresh(updatedCart, { hideGiftBox: true });
                            });
                        })
                        .catch(function(err) { if (err !== 'not-found') console.error('[gift-box] remove error:', err); });
                }
            }
        });

        $body.on('click', '.gift-cards-enlarge', function(e) {
            document.querySelectorAll(".gift-cards-zoom").forEach(el => {
                el.classList.add('hide-m');
            });
            let zoomAttr = e.currentTarget.getAttribute('data-zoom');
            let zoomTarget = document.querySelector(`.${zoomAttr}`);
            zoomTarget.classList.remove('hide-m');
        });
        $body.on('click', '.gift-cards-zoom-close', function(e) {
            document.querySelectorAll(".gift-cards-zoom").forEach(el => {
                el.classList.add('hide-m');
            });
        });

        // Gift card ATC button click
        $body.on('click', '.gift-card-atc-btn', function() {
            var btn = this;
            btn.disabled = true;
            btn.textContent = 'Adding...';
            giftCardRemoveFromCart(function() {
                giftCardAddToCart(function() {
                    fetch('/cart.js')
                        .then(function(r) { return r.json(); })
                        .then(function(cart) {
                            partialCartRefresh(cart, { showGiftCard: true });
                            btn.textContent = 'ADD TO CART';
                            setTimeout(updateGiftCardState, 50);
                        })
                        .catch(function() {
                            btn.disabled = false;
                            btn.textContent = 'ADD TO CART';
                        });
                });
            });
        });

        // ---- Gift Card cart helpers ----

        function giftCardRemoveFromCart(callback) {
            var checkbox = document.querySelector('.checkbox__gift-card');
            if (!checkbox) { if (callback) callback(); return; }
            var productIds = Object.keys(checkbox.dataset)
                .filter(function(k) { return k.startsWith('cardVariant'); })
                .map(function(k) { return Number(checkbox.dataset[k]); });

            fetch('/cart.js')
                .then(function(r) { return r.json(); })
                .then(function(cart) {
                    var removals = cart.items.filter(function(item) {
                        return productIds.includes(item.product_id);
                    });
                    if (!removals.length) { if (callback) callback(); return; }
                    var chain = Promise.resolve();
                    removals.forEach(function(item) {
                        chain = chain.then(function() {
                            return fetch('/cart/change.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                                body: JSON.stringify({ id: item.key, quantity: 0 })
                            });
                        });
                    });
                    return chain;
                })
                .then(function() { if (callback) callback(); })
                .catch(function(err) {
                    console.error('[gift-card] remove error:', err);
                    if (callback) callback();
                });
        }

        function giftCardAddToCart(callback) {
            var selectedOption = document.querySelector('.gift-cards-option.active');
            if (!selectedOption) { if (callback) callback(); return; }
            var variantId = Number(selectedOption.getAttribute('data-variant'));
            var isBlank = !!(document.querySelector('.gift-cards-form-blank') && document.querySelector('.gift-cards-form-blank').checked);
            var props = {};
            if (!isBlank) {
                var r = (document.querySelector('.gift-cards-form-recipient') ? document.querySelector('.gift-cards-form-recipient').value : '').trim();
                var s = (document.querySelector('.gift-cards-form-sender') ? document.querySelector('.gift-cards-form-sender').value : '').trim();
                var m = (document.querySelector('.gift-cards-form-message') ? document.querySelector('.gift-cards-form-message').value : '').trim();
                if (r) props.recipient_name = r;
                if (s) props.sender_name = s;
                if (m) props.message = m;
            } else {
                props.blank_card = 'Yes';
            }
            var payload = { id: variantId, quantity: 1 };
            if (Object.keys(props).length) payload.properties = props;

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: [payload] })
            })
            .then(function() { if (callback) callback(); })
            .catch(function(err) {
                console.error('[gift-card] add error:', err);
                if (callback) callback();
            });
        }

        // Partial cart UI refresh — updates only item rows, count, subtotal, gift lines
        // without rebuilding the entire #CartContainer
        function partialCartRefresh(cart, opts) {
            opts = opts || {};

            // 1. Rebuild only .ajaxcart__inner (product rows)
            var source = document.getElementById('CartTemplate').innerHTML;
            var tmpl = Handlebars.compile(source);
            var items = [];
            $.each(cart.items, function(index, cartItem) {
                var prodImg = cartItem.image != null
                    ? cartItem.image.replace(/(\.[^.]*)$/, "_180X$1").replace('http:', '')
                    : '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
                items.push({
                    key: cartItem.key,
                    line: index + 1,
                    url: cartItem.url,
                    img: prodImg,
                    name: cartItem.product_title,
                    variation: cartItem.variant_title,
                    properties: cartItem.properties,
                    itemAdd: cartItem.quantity + 1,
                    itemMinus: cartItem.quantity - 1,
                    itemQty: cartItem.quantity,
                    vendor: cartItem.vendor,
                    linePrice: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
                    unitPrice: Shopify.formatMoney(cartItem.unit_price, settings.moneyFormat),
                    discountedPrice: Shopify.formatMoney(cartItem.discounted_price, settings.moneyFormat),
                    prounitPrice: Shopify.formatMoney(cartItem.unit_price),
                    originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
                    discounts: cartItem.discounts,
                    discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
                });
            });
            var data = {
                items: items,
                note: cart.note,
                totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
                totalCartDiscount: cart.total_discount === 0 ? 0 : Shopify.formatMoney(cart.total_discount, settings.moneyFormat),
                totalCartDiscountApplied: cart.total_discount === 0 ? false : true
            };
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = tmpl(data);
            var newInner = tempDiv.querySelector('.ajaxcart__inner');
            var existingInner = document.querySelector('.ajaxcart__inner');
            if (existingInner && newInner) {
                existingInner.innerHTML = newInner.innerHTML;
            }

            // 2. Update cart count
            if ($cartCountSelector) {
                $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
                if (cart.item_count === 0) $('.cart-count-bubble').hide();
                else $('.cart-count-bubble').show();
            }
            var countEl = document.getElementById('CartCountDrawer');
            if (countEl) countEl.textContent = '(' + cart.item_count + ')';

            // 3. Update subtotal
            var formattedTotal = Shopify.formatMoney(cart.total_price, settings.moneyFormat);
            var subtotalEl = document.querySelector('.subtotal-cart-price');
            if (subtotalEl) subtotalEl.innerHTML = formattedTotal;
            var checkoutPriceEl = document.querySelector('.checkout-button-price');
            if (checkoutPriceEl) checkoutPriceEl.innerHTML = formattedTotal;

            // 4. Gift card subtotal line
            var totalGiftCard = document.querySelector('.total-gift-card');
            if (totalGiftCard) {
                if (opts.showGiftCard) {
                    totalGiftCard.classList.remove('hide-m');
                    totalGiftCard.classList.add('flex');
                } else if (opts.hideGiftCard) {
                    totalGiftCard.classList.add('hide-m');
                    totalGiftCard.classList.remove('flex');
                }
            }

            // 5. Gift box subtotal line
            var totalGiftBox = document.querySelector('.total-gift-box');
            if (totalGiftBox) {
                if (opts.showGiftBox) {
                    totalGiftBox.classList.remove('hide-m');
                    totalGiftBox.classList.add('flex');
                } else if (opts.hideGiftBox) {
                    totalGiftBox.classList.add('hide-m');
                    totalGiftBox.classList.remove('flex');
                }
            }

            // 6. "(Edit)" label — visible when any gift item is in cart
            var editLabel = document.querySelector('.gifting-edit-label');
            if (editLabel) {
                if (opts.showGiftCard || opts.showGiftBox) {
                    editLabel.classList.remove('hide-m');
                } else if (opts.hideGiftCard || opts.hideGiftBox) {
                    // Hide only if neither gift card nor gift box remains in cart
                    var cardChecked = !!(document.querySelector('.checkbox__gift-card') && document.querySelector('.checkbox__gift-card').checked);
                    var boxChecked  = !!(document.querySelector('.checkbox__gift-box') && document.querySelector('.checkbox__gift-box').checked);
                    if (!cardChecked && !boxChecked) {
                        editLabel.classList.add('hide-m');
                    }
                }
            }
        }

        // ---- End Gift Card cart helpers ----

        function updateGiftCardState() {
            var giftCardChecked = document.querySelector('.checkbox__gift-card') && document.querySelector('.checkbox__gift-card').checked;
            var atcBtn = document.querySelector('.gift-card-atc-btn');

            if (!giftCardChecked) {
                if (atcBtn) atcBtn.disabled = true;
                return;
            }

            var hasDesign = !!document.querySelector('.gift-cards-option.active');
            var isBlank = document.querySelector('.gift-cards-form-blank') && document.querySelector('.gift-cards-form-blank').checked;
            var recipient = (document.querySelector('.gift-cards-form-recipient') ? document.querySelector('.gift-cards-form-recipient').value : '').trim();
            var sender    = (document.querySelector('.gift-cards-form-sender') ? document.querySelector('.gift-cards-form-sender').value : '').trim();
            var message   = (document.querySelector('.gift-cards-form-message') ? document.querySelector('.gift-cards-form-message').value : '').trim();

            var fieldsValid = isBlank || (
                recipient.length > 0 &&
                sender.length > 0    &&
                message.length > 0
            );
            var isValid = hasDesign && fieldsValid;

            if (atcBtn) atcBtn.disabled = !isValid;

            // Show/hide per-field error hints (only when user has interacted)
            var errorDesign    = document.querySelector('.gift-error-design');
            var errorRecipient = document.querySelector('.gift-error-recipient');
            var errorSender    = document.querySelector('.gift-error-sender');
            var errorMessage   = document.querySelector('.gift-error-message');
            if (errorDesign)    errorDesign.classList.toggle('hide-m', hasDesign);
            if (errorRecipient) errorRecipient.classList.toggle('hide-m', isBlank || recipient.length > 0);
            if (errorSender)    errorSender.classList.toggle('hide-m', isBlank || sender.length > 0);
            if (errorMessage)   errorMessage.classList.toggle('hide-m', isBlank || message.length > 0);
        }

        $body.on('input', '.gift-cards-form-recipient, .gift-cards-form-sender, .gift-cards-form-message', function() {
            updateGiftCardState();
        });

        $body.on('click', '.cart__next__checkout', async function(e) {
            e.preventDefault();

            const checkbox_gift_card = document.querySelector('.checkbox__gift-card');
            const checkbox_gift_box = document.querySelector('.checkbox__gift-box');
            const checkbox_button = document.querySelector('.cart__next__checkout');
            const originalButtonContent = checkbox_button.innerHTML;
            const add_ons = [];
            const gift_props = {};

            checkbox_button.disabled = true;
            checkbox_button.innerHTML = `
                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 20 20" style="width: 1.5rem; height: 1.5rem;"><path d="M7.229 1.173a9.25 9.25 0 1011.655 11.412.75.75 0 00-1.06-1.061 7.75 7.75 0 11-9.92-9.92.75.75 0 001.06-1.061z" fill="currentColor"></path></svg>
            `;

            const checkbox_gift_card_ids = Object.keys(checkbox_gift_card.dataset)
                .filter(key => key.startsWith('cardVariant'))
                .map(key => Number(checkbox_gift_card.dataset[key]));

            try {
                // get current cart
                const cart = await fetch('/cart.js').then(res => res.json());

                // build removal payload for all gift card ids
                const removals = cart.items
                .filter(item => checkbox_gift_card_ids.includes(item.product_id))
                .map(item => ({ id: item.key, quantity: 0 }));

                // build gift card + gift box add-ons
                if (checkbox_gift_card?.checked) {
                const recipient = document.querySelector(".gift-cards-form-recipient")?.value.trim();
                const sender = document.querySelector(".gift-cards-form-sender")?.value.trim();
                const message = document.querySelector(".gift-cards-form-message")?.value.trim();
                const blank_card = document.querySelector(".gift-cards-form-blank")?.checked ? "Yes" : "No";
                if (recipient) gift_props['recipient_name'] = recipient;
                if (sender) gift_props['sender_name'] = sender;
                if (message) gift_props['message'] = message;
                if (blank_card){
                    gift_props['blank_card'] = blank_card;
                }

                document.querySelectorAll(".gift-cards-option.active").forEach(el => {
                    const variantId = Number(el.getAttribute('data-variant'));
                    const gift_input = { id: variantId, quantity: 1 };
                    if (Object.keys(gift_props).length > 0) gift_input.properties = gift_props;
                    add_ons.push(gift_input);
                });
                }

                const box_variant_id = Number(checkbox_gift_box?.getAttribute('data-box-variant'));
                const has_box = cart.items.some(item => item.variant_id === box_variant_id);

                if (checkbox_gift_box?.checked && !has_box) {
                // Add gift box if checked and not already in cart
                add_ons.push({ id: box_variant_id, quantity: 1 });
                } else if (!checkbox_gift_box?.checked && has_box) {
                // Remove gift box if unchecked and exists
                const box_item = cart.items.find(item => item.variant_id === box_variant_id);
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                    },
                    body: JSON.stringify({ id: box_item.key, quantity: 0 })
                });
                }

                // perform removals in one go if needed
                if (removals.length > 0) {
                await Promise.all(
                    removals.map(r =>
                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                        },
                        body: JSON.stringify(r)
                    })
                    )
                );
                }

                // add new ones if checked
                if (add_ons.length > 0) {
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                    },
                    body: JSON.stringify({ items: add_ons })
                });
                }

                // finally redirect
                window.location.href = '/checkout';
            } catch (err) {
                console.error('Error:', err);
                checkbox_button.disabled = false;
                checkbox_button.innerHTML = originalButtonContent;
            }
        });

        $body.on('input', '.gift-cards-form-message', function(e) {
            const charCount = document.querySelector('.gift-cards-form-message-count');
            const currentLength = e.target.value.length;
            const maxLength = 110;
            charCount.textContent = `${currentLength}/${maxLength}`;
        });

        // Add or remove from the quantity
        $body.on('click', '.ajaxcart__qty-adjust', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });

        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $body.on('focus', '.ajaxcart__qty-adjust', function() {
            var $el = $(this);

            $el.addClass('clicked');
            setTimeout(function() {
                $el.select();
                $el.removeClass('clicked');
            }, 1000);

        });

        function updateQuantity(line, qty) {
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

            if (qty === 0) {
                $row.parent().addClass('is-removed');
            }

            // Slight delay to make sure removed animation is done
            setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback);
            }, 250);
        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function() {
            var newNote = $(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function(cart) {});
        });
    };

    adjustCartCallback = function(cart) {
        const hasOtherProducts = cart.items.some(item => 
            !item.product_title.includes('Gift Box') && !item.product_title.includes('Gift Card')
        );

        if (cart.item_count > 0 && !hasOtherProducts) {
            const updates = {};
            cart.items.forEach(item => {
                if (item.product_title.includes('Gift Box') || item.product_title.includes('Gift Card')) {
                    updates[item.key] = 0;
                }
            });

            if (Object.keys(updates).length > 0) {
                const params = {
                    type: 'POST',
                    url: '/cart/update.js',
                    data: { updates: updates },
                    dataType: 'json',
                    success: function(cart) {
                        isUpdating = false;
                        updateCountPrice(cart);
                        ShopifyAPI.getCart(buildCart);
                    }
                };
                $.ajax(params);
                return;
            }
        } else {
            // Update quantity and price
            updateCountPrice(cart);
            // Reprint cart on short timeout so you don't see the content being removed
            setTimeout(function() {
                isUpdating = false;
                ShopifyAPI.getCart(buildCart);
            }, 150);
        }
    };

    createQtySelectors = function() {
        // If there is a normal quantity number field in the ajax cart, replace it with our version
        if ($('input[type="number"]', $cartContainer).length) {
            $('input[type="number"]', $cartContainer).each(function() {
                var $el = $(this),
                    currentQty = $el.val();

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });
        }
    };

    qtySelectors = function() {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = $('input[type="number"]');

        if (numInputs.length) {
            numInputs.each(function() {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Setup listeners to add/subtract from the input
            $('.js-qty__adjust').on('click', function() {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));

                var qty = validateQty(qty);

                // Add or subtract from the current quantity
                if ($el.hasClass('js-qty__adjust--plus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }

                // Update the input's number
                $qtySelector.val(qty);
            });
        }
    };

    validateQty = function(qty) {
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };

    module = {
        init: init,
        load: loadCart,
        itemAddedCallback: itemAddedCallback,
        itemErrorCallback: itemErrorCallback
    };

    return module;

}(ajaxCart || {}, jQuery));